// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-btn[data-v-619d7070] {\n  width: 268px;\n}", ""]);
// Exports
module.exports = exports;
